import validate from '@vlabs/shared/validators';
import { Control } from '@vlabs/uikit';
import { useFormContext, useWatch } from 'react-hook-form';

import { useSearchPageTranslation } from '../../../../../i18n';
import st from '../../popovers.module.sass';

export function CoordinatesTab(): JSX.Element {
  const { t } = useSearchPageTranslation();
  const { register, formState: { errors }, setValue } = useFormContext();
  const [latitude, longitude, longitudeDelta, latitudeDelta] = useWatch({ name: ['origin_latitude', 'origin_longitude', 'longitude_delta', 'latitude_delta'] });

  return (
    <div className={st.CoordinatesTabWrapper}>
      <div className={st.CoordinatesInputs}>
        <div className={st.RowInputsWrapper}>
          <div>
            <Control.Input
              id="origin_longitude"
              label={t('filters.event_filters.location.coordinates_tab.longitude') ?? ''}
              {...register('origin_longitude', {
                min: validate.gte(-180),
                max: validate.lte(180),
                validate: {
                  number: validate.number(),
                  validateLatitude: (value) => {
                    if (!value && latitude) {
                      return validate.required() as boolean;
                    }
                    return true;
                  },
                  validateDelta: (value) => {
                    if (!value && longitudeDelta) {
                      return validate.required() as boolean;
                    }
                    return true;
                  },
                },
              })}
              errors={errors}
              isClearable
              onClear={() => setValue('origin_longitude', '')}
            />
          </div>
          <div>
            <Control.Input
              id="longitude_delta"
              label={t('filters.event_filters.location.coordinates_tab.error') ?? ''}
              {...register('longitude_delta', {
                min: validate.gte(0),
                max: validate.lte(90),
                validate: validate.number(),
              })}
              errors={errors}
              isClearable
              onClear={() => setValue('longitude_delta', '')}
            />
          </div>
        </div>
        <div className={st.RowInputsWrapper}>
          <div>
            <Control.Input
              id="origin_latitude"
              label={t('filters.event_filters.location.coordinates_tab.latitude') ?? ''}
              {...register('origin_latitude', {
                min: validate.gte(-90),
                max: validate.lte(90),
                validate: {
                  number: validate.number(),
                  validateLongitude: (value) => {
                    if (!value && longitude) {
                      return validate.required() as boolean;
                    }
                    return true;
                  },
                  validateDelta: (value) => {
                    if (!value && latitudeDelta) {
                      return validate.required() as boolean;
                    }
                    return true;
                  },
                },
              })}
              errors={errors}
              isClearable
              onClear={() => setValue('origin_latitude', '')}
            />
          </div>
          <div>
            <Control.Input
              id="latitude_delta"
              label={t('filters.event_filters.location.coordinates_tab.error') ?? ''}
              {...register('latitude_delta', {
                min: validate.gte(0),
                max: validate.lte(90),
                validate: validate.number(),
              })}
              errors={errors}
              isClearable
              onClear={() => setValue('latitude_delta', '')}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
